import { IconProps } from "./Icon.model";

export function AlertCircleIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.833008C11.958 0.833008 15.167 4.04196 15.167 8C15.167 11.958 11.958 15.167 8 15.167C4.04196 15.167 0.833008 11.958 0.833008 8C0.833008 4.04196 4.04196 0.833008 8 0.833008ZM7.99707 10C7.63053 10 7.33301 10.2988 7.33301 10.667C7.33318 11.035 7.63063 11.333 7.99707 11.333H8.00293C8.36937 11.333 8.66682 11.035 8.66699 10.667C8.66699 10.2988 8.36947 10 8.00293 10H7.99707ZM8 4.66699C7.63192 4.66699 7.33318 4.96497 7.33301 5.33301V8C7.33301 8.36819 7.63181 8.66699 8 8.66699C8.36819 8.66699 8.66699 8.36819 8.66699 8V5.33301C8.66682 4.96497 8.36808 4.66699 8 4.66699Z"
        fill={fillColor}
      />
    </svg>
  );
}

